export default {
    path: '/password/edit',
    name: 'editpassword',
    component: () => import(/* webpackChunkName: "authorization" */'@/views/Authorization.vue')
};
